export default "__VITE_PUBLIC_ASSET__3ac9afe0__"